import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { max } from "rxjs/operators";

@Component({
  selector: "rfc-read-more",
  templateUrl: "./read-more.component.html",
  styleUrls: ["./read-more.component.scss"],
  standalone: true,
  
})
export class ReadMoreComponent implements OnChanges {
  @Input() text: string;
  @Input() maxLength: number;
  actualText: string;
  isCollapsed: boolean = false;
  showReadMore: boolean = true;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    this.showReadMore =
      this.maxLength !== undefined && this.text?.length > this.maxLength;
    this.transformText();
  }

  private transformText() {
    if (this.showReadMore) {
      this.actualText = !this.isCollapsed
        ? `${this.text.substr(0, this.maxLength)}...`
        : this.text;
    } else {
      this.actualText = this.text;
    }
  }

  toggleText() {
    this.isCollapsed = !this.isCollapsed;
    this.transformText();
  }
}
